module.exports = __webpack_public_path__ + "static/img/13areaA_7.1d09ebe.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/13areaA_7.png
// module id = 1015
// module chunks = 1